import { useState, useEffect } from 'react';
import { messaging, getToken, onMessage } from '../config/firebase';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useFirebaseNotification = () => {
  const [fcmToken, setFcmToken] = useState(null);
  const [notification, setNotification] = useState(null);
  const [youtubeModal, setYoutubeModal] = useState({ isOpen: false, url: '', title: '' });
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleNotificationClick = (data) => {
    console.log('Notification clicked with data:', data);
    
    if (data?.yt_url) {
      console.log('Opening YouTube modal with URL:', data.yt_url);
      setYoutubeModal({ isOpen: true, url: data.yt_url, title: data.title || '' });
    } else if (data?.web_path) {
      console.log('Navigating to:', data.web_path);
      navigate(`/admin/${data.web_path}`);
    }
  };

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      console.log("Permission : ",permission);
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
        });
        // console.log("Token of Notification : ",token);
        setFcmToken(token);
        // Send token to backend
        await sendTokenToBackend(token);
        return token;
      } else {
        console.log('Notification permission denied');
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
    }
  };

 const sendTokenToBackend = async (token) => {
  try {
    // console.log("Sending token to backend:", token);
    const storedToken = localStorage.getItem('fcm_token');
    
    if (storedToken === token || !user?.id) {
      console.log("Token already exists and is the same, skipping backend update");
      return;
    }
    const axiosInstance = (await import('../api')).default;
    await axiosInstance.put(`${import.meta.env.VITE_API_URL}/api/v1/deviceToken/user`, { 
      fcm_token: token, 
      user_id: user.id, 
      device: 3 
    });
    localStorage.setItem('fcm_token', token);
    console.log("Token updated in localStorage");
  } catch (error) {
    console.error('Error sending token to backend:', error);
  }
};


  useEffect(() => {
       if (!user?.id) {
       return;
       }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }

    // Request permission on mount
    requestPermission();

    // Listen for foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      const notificationData = payload.data || {};
      setNotification({
        title: payload.notification?.title || notificationData.title,
        body: payload.notification?.body || notificationData.body,
        data: notificationData
      });
if (notificationData.yt_url) {
        // Show YouTube modal automatically
        setYoutubeModal({ 
          isOpen: true, 
          url: notificationData.yt_url,
          title: payload.notification?.title || notificationData.title || ''
        });
        
        // Show toast without click action
        toast.info(
          <div>
            <strong>{payload.notification?.title || notificationData.title}</strong>
            <p>{payload.notification?.body || notificationData.body}</p>
          </div>,
          { autoClose: 5000 }
        );
      } else if (notificationData.web_path) {
        // Show toast with click to navigate
        toast.info(
          <div>
            <strong>{payload.notification?.title || notificationData.title}</strong>
            <p>{payload.notification?.body || notificationData.body}</p>
          </div>,
          {
            autoClose: 9000,
            onClick: () => navigate(`/admin/${notificationData.web_path}`)
          }
        );
      } else {
        // Default toast
        toast.info(
          <div>
            <strong>{payload.notification?.title || notificationData.title}</strong>
            <p>{payload.notification?.body || notificationData.body}</p>
          </div>,
          { autoClose: 5000 }
        );
      }
    });

    // Handle yt param from background notification click
    const urlParams = new URLSearchParams(window.location.search);
    const ytUrl = urlParams.get('yt');
    if (ytUrl) {
      setYoutubeModal({
        isOpen: true,
        url: decodeURIComponent(ytUrl),
        title: 'Video Update'
      });
      // Clean up the URL parameter
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    return () => unsubscribe();
  }, []);

  return { fcmToken, notification, requestPermission ,  youtubeModal,
    setYoutubeModal };
};

export default useFirebaseNotification;

